/*
 * When on mobile and the URL anchor links to a section that is
 * contained within an offscreen tab, open the tab on page load
 */

const data = {
    '#servicingPlans': 'plans',
};

function init() {
    if (window.innerWidth > 670) {
        return;
    }

    const url = new URL(window.location.href),
          anchor = url.hash;

    let offscreenTabId = '',
        button;
    
    if (anchor) {
        offscreenTabId = data[anchor];
    }

    if (offscreenTabId) {
        button = document.querySelector(`.js_openOffscreenTab[data-for-offscreen-tab=${offscreenTabId}]`);
    }

    if (button) {
        button.click();
    }
}

$(document).ready(init);
